module.exports = __webpack_public_path__ + "img/bill_black.5d3109e5.svg";